'use client';

import { useModalStore } from '@/stores/useModalStore';
import Modal from '@/components/modal/Modal';

export default function ModalWrapper() {
    const { isOpen, currentModal, closeModal } = useModalStore();

    return (
        <Modal
            isOpen={isOpen}
            onClose={closeModal}
            pcWidth={currentModal?.size?.pcWidth}
            mbWidth={currentModal?.size?.mbWidth}
            pcHeight={currentModal?.size?.pcHeight}
            mbHeight={currentModal?.size?.mbHeight}
            direction={currentModal?.direction}
            borderColor={currentModal?.borderColor}
            zIndex={currentModal?.zIndex}
        >
            {currentModal?.component || null}
        </Modal>
    );
}
